import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
  useRef,
} from "react";
import styles from "./index.module.css";
import { Progress } from "antd";
import "antd/es/progress/style/css";
import IconFont from "@meitu/xdesign-icon-font";

interface CustomProgressProps {
  loading: boolean;
  files: File[];
  onClose?: (file: File) => void;
}

const CustomProgress = forwardRef(
  ({ loading, files = [], onClose }: CustomProgressProps, ref) => {
    const [percent, setPercent] = useState<number>(0);
    const interval = useRef<NodeJS.Timeout>();

    useEffect(() => {
      if (loading) {
        // 当 loading 为 true 时，开始增加进度
        interval.current = setInterval(() => {
          setPercent((prevPercent) => {
            if (prevPercent < 90) {
              return prevPercent + 10; // 每次增加 10%
            } else {
              clearInterval(interval.current);
              return prevPercent;
            }
          });
        }, 1000);
      } else {
        // 当 loading 为 false 时，重置进度条
        setPercent(0);
      }

      // 清理副作用
      return () => {
        if (interval.current) {
          clearInterval(interval.current);
        }
      };
    }, [loading]);

    useImperativeHandle(ref, () => ({
      progressFinish: () => {
        clearInterval(interval.current);
        setPercent(100);
      },
    }));

    const close = (file: File) => {
      onClose && onClose(file);
    };

    return (
      <div className={styles.webProgress}>
        <div className={styles.webProgressText}>文件上传中...({percent})%</div>
        <Progress
          percent={percent}
          type="line"
          showInfo={false}
          strokeColor="#66A8FF"
          status="active"
          strokeWidth={6}
        />
        {files.map((v) => {
          return (
            <div className={styles.webProgressFile} key={v.lastModified}>
              <div>{v.name}</div>
              <IconFont
                className={styles.fileClose}
                fontSize={10}
                name="CrossBold"
                onClick={() => close(v)}
              />
            </div>
          );
        })}
      </div>
    );
  }
);

CustomProgress.displayName = "CustomProgress";

export default React.memo(CustomProgress);
